import { Subject, Observable } from 'rxjs';
export class BroadcastManager {
    constructor() {
        this.subjects = {};
        this.refCounts = {};
        // Name your channel something unique if you wish
        this.broadcastChannel = new BroadcastChannel('broadcast_manager_channel');
        // Listen for messages from other browser tabs
        this.broadcastChannel.onmessage = (event) => {
            const { eventName, data } = event.data || {};
            delete data.initiatorId; // remove the initiatorId from cross-tab messages because it could potentially be the same as on another tab but cant actually be the same initiator.
            if (eventName) {
                this.emitToLocalSubscribers(eventName, data);
            }
        };
    }
    /**
     * Send an event with data to subscribers in the current tab
     * and also broadcast it to other tabs.
     */
    send(eventName, data) {
        // Emit to local subscribers
        this.emitToLocalSubscribers(eventName, data);
        // Broadcast to other tabs
        this.broadcastChannel.postMessage({ eventName, data });
    }
    /**
     * Subscribe to an event. Returns an observable that will
     * emit whenever `send(eventName, data)` is called.
     */
    listen(eventName) {
        if (!this.subjects[eventName]) {
            this.subjects[eventName] = new Subject();
            this.refCounts[eventName] = 0;
        }
        // Increment the ref count for this event
        this.refCounts[eventName]++;
        // the point of this wrapper observable is so that we can capture when it is unsubscribed automatically and clean up the subject if no more listeners exist.
        return new Observable((observer) => {
            // Subscribe the observer to the requested event Subject
            const subscription = this.subjects[eventName].subscribe(observer);
            // When the wrapper observable subscription is unsubscribed, decrement refCount and potentially clean up
            return () => {
                subscription.unsubscribe();
                this.refCounts[eventName]--;
                // If no one is listening anymore, remove the Subject from memory
                if (this.refCounts[eventName] === 0) {
                    delete this.subjects[eventName];
                    delete this.refCounts[eventName];
                }
            };
        });
    }
    /**
     * Helper method to emit to local subjects only (no cross-tab).
     */
    emitToLocalSubscribers(eventName, data) {
        if (!this.subjects[eventName]) {
            return; // nobody is listening so we dont need to do anything.
            // this.subjects[eventName] = new Subject<any>();
        }
        this.subjects[eventName].next(data);
    }
}
